import { render, staticRenderFns } from "./kj.vue?vue&type=template&id=55db609b&scoped=true"
import script from "./kj.vue?vue&type=script&lang=js"
export * from "./kj.vue?vue&type=script&lang=js"
import style0 from "./kj.vue?vue&type=style&index=0&id=55db609b&prod&scoped=true&lang=css"
import style1 from "./kj.vue?vue&type=style&index=1&id=55db609b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db609b",
  null
  
)

export default component.exports